import { FormikProps } from "formik";
import CustomInput from "../../../components/common/Inputs/CustomInput";
import SelectInput, {
  OptionType,
} from "../../../components/common/Inputs/SelectInput";
import Tabs from "../../../components/common/Tabs/TabContainer";
import Tab from "../../../components/common/Tabs/Tab";
import CustomError from "../../../components/common/CustomError";
import { DealerInterface } from "../../../interfaces/dealerInterface";
import { useDistributorTypesOptions } from "../../distributortypes/hooks/useDistributorTypesOptions";
import Addresses from "./Addresses";

const taxRegimeOptions: OptionType[] = [
  { label: "Persona Fisica", value: "fisica" },
  { label: "Persona Moral", value: "moral" },
  {
    label:
      "Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas",
    value: "regimenActividadesEmpresarialesIngresosPlataformasTecnológicas",
  },
  {
    label: "Régimen Simplificado de Confianza",
    value: "regimenSimplificadoConfianza",
  },
  {
    label: "Actividades empresariales y profesionales",
    value: "actividadesEmpresarialesProfesionales",
  },
];

type DealerFormProps = {
  formik: FormikProps<DealerInterface>;
};

export const DealerForm = (props: DealerFormProps) => {
  const { formik } = props;
  const { distributorTypesOptions } = useDistributorTypesOptions();

  return (
    <>
      <Tabs>
        <Tab title="Datos Generales">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <CustomInput
              label="Nombre Comercial"
              error={
                formik.touched.name &&
                formik.errors.name &&
                Array.isArray(formik.errors.name)
                  ? formik.errors.name.join(", ")
                  : formik.errors.name
              }
              {...formik.getFieldProps("name")}
              onChange={(e) => {
                formik.handleChange(e);
              }}
            />
            <SelectInput
              label="Tipo de Distribuidor"
              options={distributorTypesOptions}
              {...formik.getFieldProps("distributorTypeId")}
              onChange={(e) => {
                formik.handleChange(e);
              }}
              error={
                formik.touched.distributorTypeId &&
                formik.errors.distributorTypeId &&
                Array.isArray(formik.errors.distributorTypeId)
                  ? formik.errors.distributorTypeId.join(", ")
                  : formik.errors.distributorTypeId
              }
            />
            <CustomInput
              label="Teléfono"
              error={
                formik.touched.phoneNumber &&
                formik.errors.phoneNumber &&
                Array.isArray(formik.errors.phoneNumber)
                  ? formik.errors.phoneNumber.join(", ")
                  : formik.errors.phoneNumber
              }
              {...formik.getFieldProps("phoneNumber")}
              onChange={(e) => {
                formik.handleChange(e);
              }}
            />
            <CustomInput
              label="Correo"
              {...formik.getFieldProps("invoiceData.email")}
              onChange={(e) => {
                formik.handleChange(e);
              }}
            />
            <SelectInput
              label="Régimen Fiscal"
              options={taxRegimeOptions}
              {...formik.getFieldProps("invoiceData.taxRegime")}
              onChange={(e) => {
                formik.handleChange(e);
              }}
            />
            <CustomInput
              label="RFC"
              {...formik.getFieldProps("invoiceData.rfc")}
              onChange={(e) => {
                formik.handleChange(e);
              }}
            />
            <CustomInput
              label="Razon Social"
              {...formik.getFieldProps("invoiceData.businessName")}
              onChange={(e) => {
                formik.handleChange(e);
              }}
            />
            <CustomInput
              label="CFDI"
              {...formik.getFieldProps("invoiceData.cfdi")}
              onChange={(e) => {
                formik.handleChange(e);
              }}
            />
            <CustomInput
              label="Representante Legal"
              {...formik.getFieldProps("invoiceData.legalRepresentative")}
              onChange={(e) => {
                formik.handleChange(e);
              }}
            />
            <CustomInput
              label="Descuento Especial"
              type="number"
              error={
                formik.touched.specialDiscount &&
                formik.errors.specialDiscount &&
                Array.isArray(formik.errors.specialDiscount)
                  ? formik.errors.specialDiscount.join(", ")
                  : formik.errors.specialDiscount
              }
              {...formik.getFieldProps("specialDiscount")}
              onChange={(e) => {
                formik.handleChange(e);
              }}
            />
          </div>
        </Tab>
        <Tab title="Direcciones">
          <Addresses list={formik.values.addresses} formik={formik} />
        </Tab>
      </Tabs>
      {formik.submitCount !== 0 && formik.values.addresses.length === 0 ? (
        <CustomError error="Debes agregar almenos una dirección" />
      ) : null}
    </>
  );
};
